import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SpeakerphoneIcon = function SpeakerphoneIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SpeakerphoneIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m11.092 3.725.283-.224v.152zm0 0-3.445.883 2.97-2.356a1.38 1.38 0 0 1 1.416-.176c.469.209.792.671.792 1.205l-1.45.372zm-3.7 2.333H7.9c.172 0 .33-.06.455-.16l2.737-2.173-3.445.883H2.3C1.547 4.608.875 5.198.875 6v2.667c0 .801.672 1.391 1.425 1.391h1.642v2.609c0 .768.623 1.391 1.391 1.391H6c.769 0 1.392-.623 1.392-1.391v-2.609h.255l2.97 2.357c.402.319.951.383 1.416.176.469-.21.792-.672.792-1.206v-1.36a2.726 2.726 0 0 0 0-5.384v-1.36l-1.45.372v7.513l-3.024-2.4a.73.73 0 0 0-.451-.158h-.508zm-1.45 0H2.325v2.55h3.617zm0 4h-.55v2.55h.55zm6.883-3.927v2.405a1.276 1.276 0 0 0 0-2.405",
      clipRule: "evenodd"
    })
  }));
};

export { SpeakerphoneIcon };
